<template>
  <b-overlay :show="loading">
    <b-alert
      variant="danger"
      :show="consultationData === undefined && !loading"
    >
      <h4 class="alert-heading">
        Error fetching Consultation Data
      </h4>

      <div class="alert-body">
        <b-link
          class="alert-link"
          :to="{ name: 'admin-consultations'}"
        >
          Consultations
        </b-link>
      </div>
    </b-alert>

    <template v-if="consultationData && patientData">
      <div>
        <b-row class="match-height">
          <b-col cols="12" md="12">
            <b-row class="match-height">
              <b-col cols="12" md="6">
                <patient-overview-card 
                  :patient-data="patientData"
                  :consultation-data="consultationData"
                  @refresh="fetchPatient"
                />
              </b-col>

              <b-col cols="12" md="6">
                <patient-vitals-card 
                  :consultation-data="consultationData" 
                  @update="update => consultationData = update" 
                />
              </b-col>
            </b-row>

            <b-row class="match-height mt-3">
              <b-col cols="12" md="3">
                <previous-medications-card
                  :patient-data="patientData"
                  :consultation-data="consultationData" 
                />
              </b-col>

              <b-col cols="12" md="3">
                <auscultations-uploads-card
                  :patient-data="patientData"
                  :consultation-data="consultationData" 
                />
              </b-col>

              <b-col cols="12" md="3">
                <patient-family-history-card 
                  :patient-data="patientData"
                  :consultation-data="consultationData" 
                />
              </b-col>

              <b-col cols="12" md="3">
                <patient-social-history-card 
                  :patient-data="patientData"
                  :consultation-data="consultationData" 
                />
              </b-col>
            </b-row>

            <b-row class="match-height mt-3">
              <b-col cols="12" md="6">
                <presenting-complaints-card 
                  :consultation-data="consultationData" 
                  @refresh="onRefreshRef('directQuestions')"
                />
              </b-col>

              <b-col cols="12" md="6">
                <presenting-complaint-history-card 
                  :consultation-data="consultationData" 
                />
              </b-col>
            </b-row>

            <b-row class="match-height mt-3">
              <b-col cols="12" md="6">
                <direct-questions-card 
                  ref="directQuestions"
                  :consultation-data="consultationData" 
                />
              </b-col>

              <b-col cols="12" md="6">
                <doctors-note-card
                  :consultation-data="consultationData" 
                />
              </b-col>
            </b-row>

            <b-row class="match-height mt-3">
               <b-col cols="12" md="6">
                <patient-diagnosis-card
                  :consultation-data="consultationData" 
                />
              </b-col>

              <b-col cols="12" md="6">
                <prescriptions-card
                  :patient-data="patientData"
                  :consultation-data="consultationData"
                  @refresh="fetchConsultationData" 
                />
              </b-col>
            </b-row>

            <b-row class="match-height mt-3">
              <b-col cols="12" md="6">
                <diagnostics-card
                  :patient-data="patientData"
                  :consultation-data="consultationData" 
                  @refresh="fetchConsultationData"
                />
              </b-col>

              <b-col cols="12" md="6">
                <treatment-advice-card
                  :consultation-data="consultationData" 
                  @refresh="fetchConsultationData"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </template>
  </b-overlay>
</template>

<script>
import { get } from "lodash";
import { BAlert, BAvatar, BBadge, BImg, BCard, BCol, BLink, BOverlay, BRow, BCardImg } from "bootstrap-vue"

import VueEasyLightbox from 'vue-easy-lightbox';
import ListTable from "@core/components/ListTable/ListTable.vue";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';


import PatientLabResultsCard from "@core/components/shared/admin/consultation/PatientLabResultsCard.vue";
import PatientMedicationsCard from "@core/components/shared/admin/consultation/PatientMedicationsCard.vue";

import DoctorsNoteCard from '@core/components/shared/admin/consultation/DoctorsNoteCard.vue';
import PatientVitalsCard from '@core/components/shared/admin/consultation/PatientVitalsCard.vue';
import PrescriptionsCard from "@core/components/shared/admin/consultation/PrescriptionsCard.vue";
import DirectQuestionsCard from "@core/components/shared/admin/consultation/DirectQuestionsCard.vue";
import PatientOverviewCard from "@core/components/shared/admin/consultation/PatientOverviewCard.vue";
import TreatmentAdviceCard from "@core/components/shared/admin/consultation/TreatmentAdviceCard.vue";
import PatientDiagnosisCard from "@core/components/shared/admin/consultation/PatientDiagnosisCard.vue";
import AuscultationsUploadsCard from "@core/components/shared/admin/consultation/AuscultationsUploadsCard.vue";
import PreviousMedicationsCard from '@core/components/shared/admin/consultation/PreviousMedicationsCard.vue';
import PatientFamilyHistoryCard from '@core/components/shared/admin/consultation/PatientFamilyHistoryCard.vue';
import PatientSocialHistoryCard from '@core/components/shared/admin/consultation/PatientSocialHistoryCard.vue';
import PresentingComplaintsCard from "@core/components/shared/admin/consultation/PresentingComplaintsCard.vue";
import PresentingComplaintHistoryCard from "@/@core/components/shared/admin/consultation/PresentingComplaintHistoryCard.vue";

import DiagnosticsCard from "@core/components/shared/admin/consultation/DiagnosticsCard.vue";

export default {
  components: {
    ListTable,
    VueEasyLightbox,
    BCardImg,
    BOverlay,
    BAlert,
    BAvatar,
    BLink,
    BImg,
    BBadge,
    BRow,
    BCol,
    BCard,
    // components
    DoctorsNoteCard,
    PrescriptionsCard,
    PatientVitalsCard,
    TreatmentAdviceCard,
    PatientOverviewCard,
    DirectQuestionsCard,
    PatientDiagnosisCard,
    PatientLabResultsCard,
    PatientMedicationsCard,
    PreviousMedicationsCard,
    PatientSocialHistoryCard,
    PresentingComplaintsCard,
    PatientFamilyHistoryCard,
    AuscultationsUploadsCard,
    PresentingComplaintHistoryCard,

    DiagnosticsCard,
  },
  directives: {},
  data(){
    return {
      loading: false,
      patientData: null,
      consultationData: null,
    }
  },
  created() {
    this.fetchConsultationData();
  },
  methods: {
    async fetchConsultationData(){
      try {
        this.loading = true;
        const { id } = this.$route.params;

        const response = await this.useJwt().mainService.consultations.fetch(id);
        this.consultationData = get(response, 'data.data');
        this.fetchPatient()
      } catch (error){
        this.consultationData = undefined;

        const error_message = get(error, "response.data.message") || error.message
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
    async fetchPatient(){
      try {
        this.loading = true;
        const { patient_id } = this.consultationData

        const response = await this.useJwt().mainService.patients.fetch(patient_id);
        this.patientData = get(response, 'data.data')
      } catch (error){
        this.patientData = undefined;

        const error_message = get(error, "response.data.message") || error.message
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            variant: 'danger',
            text: error_message,
            icon: 'AlertTriangleIcon',
          },
        });
      } finally {
        this.loading = false
      }
    },
    onRefreshRef(ref){
      if (this.$refs[ref]){
        this.$refs[ref].fetchAllData();
      }
    }
  }
}
</script>
